<div class="gallery local_images_gallery">
    <appImageEditorGallery :items="items" :hideDelete="false" />
</div>

